import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkReassignResultEntity } from '../../../domain/entities/bulk-reassign-result.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { BulkReassignInvestigationsCommand } from './bulk-reassign-investigations.command';

@Injectable({ providedIn: 'root' })
export class BulkReassignInvestigationsUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(command: BulkReassignInvestigationsCommand): Observable<BulkReassignResultEntity> {
    return this._repository.bulkReassign({
      investigationIds: command.investigationIds,
      newPrimaryUserId: command.newPrimaryUserId,
      reason: command.reason,
    });
  }
}
